import React, { useState } from 'react'
import { Icon, Button } from 'antd'
import ReactHTMLTableToExcel from 'react-html-table-to-excel'
import moment from 'moment'
import SewingThreadCopyModal from './SewingThreadCopyModal'

const COLOR_SWATCH = {
    GREY: '#8c8c8c',
    WHITE: '#ffffff',
    BLACK: '#000000',
    RED: '#e02020',
}

function ColorChip({ label, code, struckThrough }) {
    return (
        <span className={`ColorChip${struckThrough ? ' struck-through' : ''}`}>
            <i className="swatch" style={{ backgroundColor: COLOR_SWATCH[code] || '#d9d9d9' }} />
            {label} · {code}
        </span>
    )
}

function SewingThreadWarning({ data }) {
    const [copyModalVisible, setCopyModalVisible] = useState(false)
    const { total_items = 0, total_scanned_items = 0, summary = [], items = [] } = data || {}
    const unchangedItems = total_scanned_items - total_items

    const batchList = [...new Set(items.map(i => i.batch_name))].join('-')
    const exportFilename = `mau-chi-may_${batchList}_${moment().format('YYYYMMDD-HHmm')}`

    const handlePrint = () => {
        const cleanup = () => {
            document.body.classList.remove('PrintingSewingThreadTable')
            window.removeEventListener('afterprint', cleanup)
        }
        window.addEventListener('afterprint', cleanup)
        document.body.classList.add('PrintingSewingThreadTable')
        window.print()
    }

    return (
        <div className="SewingThreadWarning mt-4">
            <div className="WarningHeader no-print">
                <div className="WarningHeaderText">
                    <div className="TopBlock">
                        <Icon type="warning" theme="twoTone" twoToneColor="#faad14" />
                        <span> {total_items} item có màu chỉ may khác với giá trị đã in trên QR</span>
                    </div>
                    <div className="TopBlockDesc">
                        Mapping màu chỉ đã được cập nhật sau khi các item này được in. QR trên mảnh không sửa được
                        — cần bàn giao danh sách này kèm lệnh may cho đối tác.
                    </div>
                </div>

                <div className="ActionButtons">
                    <Button icon="copy" onClick={() => setCopyModalVisible(true)}>Copy danh sách</Button>
                    <Button
                        icon="download"
                        onClick={() => document.getElementById('SewingThreadExportBtn').click()}
                    >
                        Export
                    </Button>
                    <Button icon="printer" onClick={handlePrint}>In</Button>
                </div>
            </div>

            <div className="MiddleBlock no-print">
                Tổng hợp: {summary.map((s, idx) => (
                    <React.Fragment key={`${s.from}-${s.to}`}>
                        {idx > 0 && ' · '}
                        <b>{s.from_label} → {s.to_label}: {s.quantity} item</b>
                    </React.Fragment>
                ))}
                {unchangedItems > 0 && <> · {unchangedItems} item còn lại không đổi</>}
            </div>

            <table className="SewingThreadTable">
                <thead>
                    <tr>
                        <th>Lô</th>
                        <th>Barcode item</th>
                        <th>SKU / Size</th>
                        <th>Màu chỉ trên QR (đã in)</th>
                        <th>Màu chỉ cần dùng khi may</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map(i => (
                        <tr key={i.barcode}>
                            <td>{i.batch_name}</td>
                            <td>{i.barcode}</td>
                            <td>{i.sku} / {i.size}</td>
                            <td><ColorChip label={i.printed_label} code={i.printed} struckThrough /></td>
                            <td><ColorChip label={i.current_label} code={i.current} /></td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className="BottomBlock no-print">
                Item đã bàn giao cho đối tác (status ≥ sewing) không xuất hiện trong danh sách này — trường hợp đó chỉ còn được xử lý tại QC hoàn thành.
            </div>

            {copyModalVisible &&
                <SewingThreadCopyModal
                    visible={copyModalVisible}
                    items={items}
                    onClose={() => setCopyModalVisible(false)}
                />
            }

            <div style={{ display: 'none' }}>
                <table id="SewingThreadExportTable">
                    <thead>
                        <tr>
                            <th>Lô</th><th>Barcode item</th><th>SKU / Size</th>
                            <th>Màu chỉ trên QR (đã in)</th><th>Màu chỉ cần dùng khi may</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map(i => (
                            <tr key={i.barcode}>
                                <td>{i.batch_name}</td>
                                <td>{i.barcode}</td>
                                <td>{i.sku} / {i.size}</td>
                                <td>{i.printed_label} · {i.printed}</td>
                                <td>{i.current_label} · {i.current}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <ReactHTMLTableToExcel
                    id="SewingThreadExportBtn"
                    table="SewingThreadExportTable"
                    filename={exportFilename}
                    sheet="MauChiMay"
                    buttonText="Export Excel"
                />
            </div>
        </div>
    )
}

export default SewingThreadWarning
